/* Healthbio — eased in-page scrolling.
   Replaces the browser's instant hash jump with a timed, eased scroll and
   offsets the landing position by the sticky header height so targets are
   never hidden underneath it. Site-wide: loaded by sections/hb-header.liquid. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function header() { return document.getElementById('hbHeader'); }

  function offset() {
    var h = header();
    var hh = h ? h.getBoundingClientRect().height : 0;
    return hh + 14;
  }

  function closestAnchor(node) {
    while (node && node !== document) {
      if (node.tagName && node.tagName.toLowerCase() === 'a') return node;
      node = node.parentNode;
    }
    return null;
  }

  function target(hash) {
    if (!hash || hash === '#') return null;
    try { return document.querySelector(hash); } catch (e) { return null; }
  }

  function yOf(el) {
    return Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - offset());
  }

  // slow at both ends, quick through the middle
  function ease(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  var running = null;

  function glide(to, done) {
    var from = window.pageYOffset;
    var dist = to - from;
    if (Math.abs(dist) < 2) { if (done) done(); return; }

    // longer journeys take longer, within sane bounds
    var dur = Math.min(1250, Math.max(560, Math.abs(dist) * 0.55));
    var start = null;
    var id = {};
    running = id;

    function step(now) {
      if (running !== id) return;              // a newer scroll took over
      if (start === null) start = now;
      var p = Math.min(1, (now - start) / dur);
      window.scrollTo(0, from + dist * ease(p));
      if (p < 1) requestAnimationFrame(step);
      else { running = null; if (done) done(); }
    }
    requestAnimationFrame(step);
  }

  // cancel on manual input so the page never fights the user
  ['wheel', 'touchstart', 'keydown'].forEach(function (evt) {
    window.addEventListener(evt, function () { running = null; }, { passive: true });
  });

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var a = closestAnchor(e.target);
    if (!a) return;

    var raw = a.getAttribute('href') || '';
    var hash = null;

    if (raw.charAt(0) === '#') {
      hash = raw;
    } else if (raw.indexOf('#') > -1) {
      try {
        var u = new URL(a.href, window.location.href);
        if (u.pathname === window.location.pathname && u.host === window.location.host && u.hash) hash = u.hash;
      } catch (err) { /* ignore */ }
    }

    var el = target(hash);
    if (!el) return;

    e.preventDefault();

    if (reduce) {
      window.scrollTo(0, yOf(el));
      history.replaceState(null, '', hash);
      return;
    }

    glide(yOf(el), function () {
      history.replaceState(null, '', hash);
      el.setAttribute('tabindex', '-1');
      el.focus({ preventScroll: true });
    });
  });

  // arriving with a hash already in the URL: re-seat it under the header
  window.addEventListener('load', function () {
    var el = target(window.location.hash);
    if (!el) return;
    setTimeout(function () { window.scrollTo(0, yOf(el)); }, 40);
  });
})();
